function Spinner({ size = 20, color = "#00f5ff", trackColor = "rgba(0,245,255,0.15)" }) {
  return (
    <div
      className="rq-spinner"
      style={{
        width: size,
        height: size,
        border: `2px solid ${trackColor}`,
        borderTopColor: color,
        borderRadius: "50%",
        display: "inline-block",
        flexShrink: 0,
      }}
    />
  );
}

export function LoadingLine({ label, size = 16 }) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "10px",
        color: "#00f5ff",
        letterSpacing: "3px",
        fontSize: "12px",
      }}
    >
      <Spinner size={size} />
      <span>{label}</span>
    </div>
  );
}

// Suspense fallback for lazy-loaded page components (see React.lazy usages)
export function PageFallback() {
  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#020817",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LoadingLine label="LOADING..." />
    </div>
  );
}

export default Spinner;
